;(function() {
  'use strict'

  Service.$inject = ["glDialog", "glUtils", "glAuthService", "configService"];
  angular.module('app.core').service('creditTransactionsExporter', Service)

  /* @ngInject */
  function Service(glDialog, glUtils, glAuthService, configService) {
    this.show = show
    this.getDownloadUrl = getDownloadUrl

    function show() {
      // prettier-ignore
      var template = [
        '<gl-dialog class="credit-transactions-exporter__dialog">',
          '<credit-transactions-exporter on-cancel="dialog.cancel()"/>',
        '</gl-dialog>',
      ]
      glDialog.show({
        template: template.join(' '),
        closeOnOutsideClick: true,
      })
    }

    function getDownloadUrl(start, end) {
      var token = glAuthService.getToken()
      var endpoint = configService.getApiUrl('/credit-transactions-export')
      var url = glUtils.addParams(endpoint, {
        type: 'csv',
        startAt: start.toISOString(),
        endAt: end.toISOString(),
        api_token: token,
      })
      return url
    }
  }
})()
